import { Component, computed, inject, ChangeDetectionStrategy } from '@angular/core';
import { UtilityService } from '@eforall/common';
import { GridContentWidget, PageTabsMainTabGridSize } from '@eforall/dashboard';
import { Event } from '@interfaces';
import { AppService } from '../../../../../services';
import { DeliveryAreaService } from '../../../delivery-area.service';
import { DeliveryEventsService } from '../../delivery-events.service';
import { getSetup } from './grid/get-setup';


@Component({
	selector: 'delivery-past-events-view-part',
	standalone: true,
	imports: [GridContentWidget],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: './past-events-view.part.html',
})
export class PastEventsViewPart {

	private readonly util = inject(UtilityService);
	private readonly app = inject(AppService);
	private readonly pageService = inject(DeliveryEventsService);
	private readonly areaService = inject(DeliveryAreaService);

	public setup = getSetup(this.util, this.app);

	public pageTabsGridSize = computed<PageTabsMainTabGridSize | undefined>(() => {
		if (this.pageService.layout()) return { layout: this.pageService.layout()!, viewSelector: true };
		return undefined;
	});

	public pastEvents = computed<Event[]>(() => this.areaService.deliveryData()?.events.filter(e => e.status === 'Past') ?? []);
}